@if (product$ | async; as product) {
<planone-modal>
  @if (product?.brand && exhibitor$ | async; as exhibitor) {
  <ng-template #description>
    <ng-container i18n="@@featureProductDetails-countryAvailability-brand">
      {{ product?.brand?.name }} - eine Marke von
      <a mat-dialog-close [routerLink]="['/fairs', exhibitor.fair_id, 'exhibitors', exhibitor.id]">
        {{ exhibitor.name }}
      </a>
    </ng-container>
  </ng-template>
  }
  <ng-template #headline>
    <ng-container i18n="@@featureProductDetails-countryAvailability-title">
      Länderverfügbarkeit von {{ product.name }}
    </ng-container>
  </ng-template>
  <ng-template #content>
    @if (product?.countries) {
    <ul>
      @for (country of product?.countries; track trackByCountry($index, country)) {
      <li>{{ country }}</li>
      }
    </ul>
    } @if (!product?.countries) {
    <span i18n="@@featureProductDetails-countryAvailability-notAvailable">
      Dieses Produkt ist aktuell in keinem Land verfügbar.
    </span>
    }
  </ng-template>
</planone-modal>
}
